import { render, staticRenderFns } from "./FormBuilderSettingsButton.vue?vue&type=template&id=2e1ee2d8"
import script from "./FormBuilderSettingsButton.vue?vue&type=script&lang=js"
export * from "./FormBuilderSettingsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports